import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { auth, profileAPI, accountAPI, kycAPI, transactionAPI } from "services";

const universalStore = (set, get) => ({
  accountId: null,
  accounts: null,
  transactionId: null,
  user: null,
  profile: null,
  transactions: null,
  isReminderChanged: false,
  selectedMonth: new Date(),

  // activeComponent:"edit",
  fetchInitialData: async () => {
    try {
      const [user, accounts, userBasic, creditLedger] = await Promise.all([
        auth.fetchUser(),
        accountAPI.getAccounts(),
        profileAPI.getProfileBasics(),
        transactionAPI.getUserCreditLedger()
      ]);
      //Update Global State
      set({ user, accounts, userBasic, creditLedger, selectedMonth: new Date() });
    } catch (error) {
      console.error("Failed to fetch initial data", error);
    }
  },

  write: (obj) => {
    if (typeof obj === 'function') {
      const result = obj(get()); // Get the current state and pass it to the function
      set(result);
      return;
    }

    //Update Global State
    set(state => ({ ...state, ...obj }));
  },
});

const useUniversalStore = create(
  devtools(universalStore, { name: "Universal Store" })
);

export default useUniversalStore;
